import { LinkProps } from 'next/dist/client/link';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { PropsWithChildren, VFC } from 'react';

import useAccessToken from '@/hooks/useAccessToken';

import styles from './LinkToAuthorizedRoute.module.scss';

type Props = PropsWithChildren<LinkProps>;

const LinkToAuthorizedRoute: VFC<Props> = ({
  children,
  href,
  ...props
}: Props) => {
  const { accessToken, requestSignature } = useAccessToken();
  const router = useRouter();

  const handleLinkClick = async () => {
    const result = await requestSignature();
    // navigate to authorized route after signing
    if (result) {
      await router.push(href);
    }
  };

  // render link component if access token is active
  if (accessToken) {
    return (
      <Link href={href} {...props}>
        {children}
      </Link>
    );
  }

  // render link as button to show signature prompt
  return (
    <button type="button" className={styles.button} onClick={handleLinkClick}>
      {children}
    </button>
  );
};

export default LinkToAuthorizedRoute;
